@if (data.titleLabel) {
    <h2 mat-dialog-title class="tw-font-bold">{{ data.titleLabel | translate }}</h2>
}
<mat-dialog-content class="tw-whitespace-pre-wrap">{{ data.messageLabel || 'Title' | translate }}</mat-dialog-content>
<mat-dialog-actions align="end" class="tw-px-5">
    <button mat-button mat-dialog-close cdkFocusInitial color="primary" class="tw-text-base tw-font-medium">
        {{ (data.confirmLabel || 'Ok') | translate }}
    </button>
</mat-dialog-actions>
